// Return from the collection grid before leaving its parent category panel.
document.addEventListener('click', (event) => {
  const backButton = event.target.closest?.('.hiva-mobile-menu [data-action="close-panel"]');
  if (!backButton || !window.matchMedia('(max-width: 999px)').matches) return;

  const disclosure = backButton.closest('.header-sidebar__sub-panel')?.querySelector('.hiva-collection-disclosure[open]');
  if (!disclosure) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  disclosure.closest('accordion-disclosure').close();
  disclosure.querySelector('summary').focus({ preventScroll: true });
}, { capture: true });

// Prestige clears native open attributes on hide; synchronize its accordion state too.
document.addEventListener('dialog:after-hide', (event) => {
  if (!event.target.matches?.('.hiva-mobile-menu')) return;
  event.target.querySelectorAll('.hiva-collection-disclosure').forEach((disclosure) => {
    disclosure.closest('accordion-disclosure').close();
  });
}, { capture: true });
